import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import ReportingType, {
  IReportingType
} from "../../../model/reporting/ReportingType";
import ReportingTypeForm from "./ReportingTypeForm";

export interface State {}

export interface UpdateReportingTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IReportingType;
  codebooks: any[];
}

class UpdateReportingTypeForm extends React.Component<
  UpdateReportingTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updateReportingTypeData;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updateReportingTypeData = ReportingType(values);
          updateReportingTypeData.code = rowData.code;
        }
      });
      return updateReportingTypeData;
    });
  }

  render() {
    const { translate, rowData, codebooks } = this.props;

    const {
      getFieldDecorator,
      getFieldValue
    } = this.props.form;

    return (
      <ReportingTypeForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
        codebooks={codebooks}
        getFieldValue={getFieldValue}
      />
    );
  }
}

export default UpdateReportingTypeForm;
